const IDENTIFIER_META = {
  orcid: {
    label: "ORCID",
    href: (value) => `https://orcid.org/${value}`,
  },
  scopus: {
    label: "Scopus",
    href: (value) =>
      `https://www.scopus.com/authid/detail.uri?authorId=${value}`,
  },
  google: {
    label: "Google Scholar",
    href: (value) => `https://scholar.google.com/citations?user=${value}`,
  },
};

function getIdentifierHref(type, value) {
  if (!value) return null;
  if (/^https?:\/\//i.test(value)) return value;
  const meta = IDENTIFIER_META[type];
  return meta ? meta.href(value) : null;
}

const chipClassName =
  "inline-flex max-w-full items-center gap-1.5 rounded-full border border-blue-100 bg-white px-3 py-1 text-sm text-blue-900";

export function AuthorIdentifiers({ identifiers }) {
  if (!identifiers) return null;

  const identifierEntries = Object.entries(identifiers).filter(([, values]) =>
    values.some(Boolean)
  );

  if (identifierEntries.length === 0) return null;

  return (
    <div className="mx-auto my-2 flex w-full flex-col items-center gap-2 border-b border-gray-300 p-2 md:w-3/4">
      {identifierEntries.map(([name, values]) => {
        const type = name.toLowerCase();
        const label = IDENTIFIER_META[type]?.label || name;

        return (
          <div
            key={name}
            className="flex flex-wrap items-center justify-center gap-2"
          >
            <span className="text-sm font-medium text-slate-600">{label}</span>
            {values.filter(Boolean).map((value) => {
              const href = getIdentifierHref(type, value);
              if (href) {
                return (
                  <a
                    key={value}
                    href={href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${chipClassName} transition-shadow hover:border-blue-300 hover:shadow-sm hover:underline`}
                  >
                    <span className="truncate">{value}</span>
                  </a>
                );
              }
              return (
                <span key={value} className={chipClassName}>
                  <span className="truncate">{value}</span>
                </span>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}
